//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { createUser } from 'api/prokey/prokey.websocket';

// === STYLES ===
import MuiAlert from '@mui/material/Alert';

import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
} from '@mui/material';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

//#endregion

function AddUserDialog(props) {
  //#region [VALUES]
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');

  const [showAlert, setShowAlert] = useState(false);
  const [alertErrText, setAlertErrText] = useState('');

  //#endregion

  //#region [EFFECT]

  useEffect(() => {}, [firstName]);

  //#endregion

  //#region [MODIFY]

  function addUser() {
    // Check form, make sure we have all the data we want and it's well formatted
    let errorText = '';
    if (!firstName) errorText += ', First Name must be filled';
    if (!lastName) errorText += ', Last Name must be filled';
    if (!username) errorText += ', Username must be filled';
    if (!email) errorText += ', Email must be filled';
    if (!company) errorText += ', Company Name must be filled';

    if (errorText) {
      setAlertErrText(errorText.substring(2));
      setShowAlert(true);
      return false;
    } else {
      // Submit data to backend api
      let userData = {
        firstName: firstName,
        lastName: lastName,
        username: username,
        email: email,
        company: company,
      };

      createUser(userData);     

      return true;
    }
  }

  const resetData = () => {
    setFirstName('');
    setLastName('');
    setUsername('');
    setEmail('');
    setCompany('');
  };

  const handleSubmitAddUser = (e) => {
    addUser();
    resetData();
  };

  const handleSubmitAddUserAndClose = (e) => {
    if (addUser()) handleClose();
    resetData();
  };

  const handleClose = () => {
    props.setShowDialog(false);
    handleDismissAlert();
    resetData();
  };

  const handleDismissAlert = () => {
    setShowAlert(false);
    setAlertErrText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT

  const handleErrClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };

  const displayError = () => {
    return (
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleErrClose}>
        <div>
          <Alert onClose={handleErrClose} severity='error'>
            {alertErrText}
          </Alert>
        </div>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  function displayAddUserModal() {
    return props.showDialog ? (
      <div>
        <Dialog open={props.showDialog} onClose={handleClose} aria-labelledby='form-dialog-title'>
          <DialogTitle id='form-dialog-title'>Add User</DialogTitle>
          <DialogContent>
            <DialogContentText>Enter user information</DialogContentText>
            <TextField
              autoFocus
              margin='dense'
              id='username'
              label='Username'
              type='text'
              fullWidth
              value={username}
              autoComplete='off'
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
            <TextField
              margin='dense'
              id='name'
              label='First Name'
              type='text'
              fullWidth
              value={firstName}
              autoComplete='off'
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
            <TextField
              margin='dense'
              id='last-name'
              label='Last Name'
              type='text'
              fullWidth
              value={lastName}
              autoComplete='off'
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
            <TextField
              margin='dense'
              id='email'
              label='Email'
              type='email'
              fullWidth
              value={email}
              autoComplete='off'
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <TextField
              margin='dense'
              id='company'
              label='Company'
              type='text'
              fullWidth
              value={company}
              autoComplete='off'
              onChange={(e) => {
                setCompany(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              Cancel
            </Button>
            <Button onClick={handleSubmitAddUser} color='primary'>
              Add
            </Button>
            <Button onClick={handleSubmitAddUserAndClose} color='primary'>
              Add & Close
            </Button>
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    ) : null;
  }

  //#endregion

  return displayAddUserModal();
}

export { AddUserDialog };
